import React from 'react'

const Quizscoreskeleton = () => {
    return (
        <div className="score-skeleton">
            <div className="score-skeleton-header">
                <div className="score-skeleton-title shimmer"></div>
                <div className="score-skeleton-button shimmer"></div>
            </div>

            <div className="score-skeleton-card">
                <div className="score-skeleton-user">
                    <div className="score-skeleton-text shimmer"></div>
                    <div className="score-skeleton-subtext shimmer"></div>
                    <div className="score-skeleton-avatar shimmer"></div>
                </div>

                <div className="score-skeleton-section shimmer"></div>
                <div className="score-skeleton-section shimmer"></div>

                <div className="score-skeleton-details">
                    {[...Array(4)].map((_, i) => (
                        <div className="score-skeleton-line shimmer" key={i}></div>
                    ))}
                </div>
            </div>

            <div className="score-skeleton-toppers">
                <div className="score-skeleton-title shimmer"></div>
                {[...Array(3)].map((_, i) => (
                    <div className="score-skeleton-topper shimmer" key={i}>
                        <div className="score-skeleton-topper-avatar shimmer"></div>
                        <div>
                            <div className="score-skeleton-text shimmer"></div>
                            <div className="score-skeleton-subtext shimmer"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Quizscoreskeleton